import { useQuery } from "react-query";
import { get } from "./http";

export interface StatFurniture {
    [x: string]: string;
    erpId: string;
    name: string;
    brandId: string;
    country: string;
    managerName: string;
}

const useStatsFurnitures = () =>
  useQuery<StatFurniture[]>([], () => get("/furnitures/statistics"), { staleTime: Infinity });



export { useStatsFurnitures };